<style scoped>
  @import "../../assets/css/table-list.css";
</style>
<style>
  .table-new thead tr th:nth-child(1),
  .table-new tbody tr th:nth-child(1){
    min-width: 50px;
    max-width: 50px;
  }
  .table-new tbody .ivu-table-cell{
     min-width: 100px;
     max-width: 200px;
   }
  .ivu-form-item-content{ line-height: 33px; }
</style>
<template>
  <div>
    <h3 class="title">租户信息列表 </h3>
    <div class="margin-bottom-10 header-group">
      <Select v-model="params.CondList[0].Key" @on-change="change_condList">
        <Option v-for="(item,index) in d_search_key" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Input v-model="params.CondList[0].Value" placeholder="请输入搜索内容" />
      <Button type="primary" @click="search()">查询</Button>
      <Button type="primary" @click="to_add()" class="right">新增</Button>
      <Button type="error" @click="to_delMore" class="btn-right">批量删除</Button>
      <Button type="primary" @click="to_export" class="btn-right" :loading="loading_export">导出</Button>
      <Button type="primary" @click="to_export('all')" class="btn-right" :loading="loading_export_all">导出全部</Button>
    </div>
    <div>
      <Table ref="selection" class="table-new" border :columns="d_columns" :data="d_data" @on-selection-change="get_select_data"></Table>
    </div>
    <div class="margin-top-20">
      <Page :total="d_total" show-sizer show-total @on-change="flip" @on-page-size-change="change_size" class="pull-right"></Page>
      <div class="clear-both"></div>
    </div>
    <Modal
      v-model="d_modal_add"
      :title="d_modal_title"
      width="800px"
      footer-hide>
      <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="100">
        <Row>
          <Col span="12">
            <FormItem label="租赁单位/人" prop="Name" >
              <Input v-model="add_params.Name" placeholder="请输入租赁单位"></Input>
            </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="联系人" prop="TouchMan">
            <Input v-model="add_params.TouchMan" placeholder="请输入联系人"></Input>
          </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="身份证号" prop="IDNum">
              <Input v-model="add_params.IDNum" placeholder="请输入身份证号"></Input>
            </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="营业执照编号" prop="BusinessLicense">
            <Input v-model="add_params.BusinessLicense" placeholder="请输入营业执照编号"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="手机号码" prop="Phone">
            <Input v-model="add_params.Phone" placeholder="请输入手机号码"></Input>
          </FormItem>
          </Col>
          <!--<Col span="12">-->
            <!--<FormItem label="性别" prop="Sex">-->
              <!--<RadioGroup v-model="add_params.Sex" style="height: 33px;">-->
                <!--<Radio label="男">男</Radio>-->
                <!--<Radio label="女">女</Radio>-->
              <!--</RadioGroup>-->
            <!--</FormItem>-->
          <!--</Col>-->
          <Col span="12">
            <FormItem label="邮箱" prop="Email">
              <Input v-model="add_params.Email" placeholder="请输入邮箱"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="QQ" prop="QQ">
              <Input v-model="add_params.QQ" placeholder="请输入QQ号码"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="微信号" prop="Wechat">
              <Input v-model="add_params.Wechat" placeholder="请输入微信号"></Input>
            </FormItem>
          </Col>
          <!--<Col span="12">-->
            <!--<FormItem label="地址" prop="Address">-->
              <!--<Input v-model="add_params.Address" placeholder="请输入常住地址"></Input>-->
            <!--</FormItem>-->
          <!--</Col>-->
          <Col span="24">
          <FormItem label="备注" prop="Notes">
            <Input v-model="add_params.Notes" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
          </FormItem>
          </Col>
          <Col span="12">
              <FormItem label="身份证扫描件" prop="photos1" style="height: auto;">
                <Upload
                  ref="IDImgList"
                  :default-file-list="d_defaultList_ID"
                  :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=customer&&type=身份证'"
                  multiple
                  :headers="{Authorization:token}"
                  :on-preview="img_preview">
                  <Button icon="ios-cloud-upload-outline">请选择文件</Button>
                </Upload>
             </FormItem>
          </Col>
          <Col span="12">
              <FormItem label="营业执照扫描件" prop="photos2" style="height: auto;">
                <Upload
                  ref="businessImgList"
                  :default-file-list="d_defaultList_business"
                  :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=customer&&type=营业执照'"
                  multiple
                  :headers="{Authorization:token}"
                  :on-preview="img_preview">
                  <Button icon="ios-cloud-upload-outline">请选择文件</Button>
                </Upload>
              </FormItem>
          </Col>
        </Row>
        <Modal title="图片预览" v-model="d_img_visible" @on-cancel="cancel_preview" footer-hide>
          <img :src="d_img_name" v-if="d_img_visible" style="width: 100%">
        </Modal>
        <FormItem>
          <Button type="primary" @click="edit_confirm('formValidate')">保存</Button>
          <Button @click="add_modal_cancel" class="margin-left10">取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import apiUser from '@/api/user.js';
  import mixin from '@/components/common/mixin.js';
  export default {
    name:'customerData_page',
    mixins: [mixin],
    data() {
      return {
        token:'',
        params: {},
        add_params:{},
        ruleValidate: {
          Name: [
            { required: true, message: '产权证号为必填项', trigger: 'blur' }
          ],
          // IDNum: [
          //   { required: true, message: '身份证为必填项', trigger: 'blur' }
          // ],
          // BusinessLicense: [
          //   { required: true, message: '营业执照必填项', trigger: 'blur' }
          // ],
          // TouchMan: [
          //   { required: true, message: '联系人为必填项', trigger: 'blur' }
          // ],
          Phone: [
            { required: true, message: '手机号码为必填项', trigger: 'blur' }
          ],
        },
        d_total: 0,
        d_page: 1,
        d_page_size: 10,
        d_search_key:[
          {
            value: 'c.ID',
            label: '租户编号'
          },
          {
            value: 'c.Name',
            label: '租赁单位/人'
          },
          {
            value: 'c.BusinessLicense',
            label: '营业执照'
          },
          {
            value: 'c.IDNum',
            label: '身份证号'
          },
          {
            value: 'c.TouchMan',
            label: '联系人'
          },
          {
            value: 'c.Phone',
            label: '手机'
          }
        ],
        d_modal_add: false,
        d_modal_title: '',
        d_columns: [
          {
            type: 'selection',
             width:60,
            align: 'left'
          },
          {
            title: '租户编号',
            key: 'ID',

          },
          {
            title: '租赁单位/人',
            key: 'Name',

          },
          {
            title: '联系人',
            key: 'TouchMan',

          },
          {
            title: '手机',
            key: 'Phone',

          },
          {
            title: '身份证号',
            key: 'IDNum',

          },
          {
            title: '营业执照',
            key: 'BusinessLicense',

          },
          {
            title: '备注',
            key: 'Notes',
            ellipsis: true
          },
          {
            title: "操作",
            key: "do",
            fixed:'right',
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_edit(params.row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要删除该条数据吗？</p>",
                          onOk: () => {
                            this.to_delete(params.row.ID);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ])
            }
          }
        ],
        d_data: [],
        d_modal_type: '',
        d_defaultList_ID:[],
        d_defaultList_business:[],
        d_img_visible: false,
        d_img_name:'',
        loading_export:false,
        loading_export_all:false,
        d_del_data:'' // 批量删除
      };
    },
    methods: {
      change_condList(value){
        if(value=='c.ID'){
          this.params.CondList[0].Operator = '=';
        }else {
          this.params.CondList[0].Operator = 'like';
        }
      },
      search() {
        this.params.PageIndex = 1;
        this.pull_data();
      },
      flip(page) { //翻页条件，每页多少条，多少页
        this.params.PageIndex = page;
        this.params.PageSize = this.d_page_size;
        this.pull_data();
      },
      change_size(size) { //改变limit 每页显示多少条
        this.params.PageSize = size;
        this.pull_data();
      },
      pull_data() {
        let _this = this;
        apiUser.getList.post(this.params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let requestResult = _data.data.Data;
            _this.d_total = requestResult.Total;
            _this.d_data = requestResult.RowsList;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_add(){
        this.d_modal_add = true;
        this.d_modal_type = 'add';
        this.d_modal_title = '添加用户';
        this.add_params = JSON.parse(JSON.stringify(apiUser.add.data));
      },
      to_edit(row){
        this.d_modal_type = 'edit';
        this.d_modal_title = '修改用户';
        apiUser.getEditDto(row.ID).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.add_params = _data.data.Data;
            let fileList = this.add_params.FileList;
            let defaultListID = [];
            let defaultListBusiness = [];
            for(let i=0;i<fileList.length;i++){
              let thisFile = {};
              thisFile.name = fileList[i].SaveName;
              thisFile.url = fileList[i].SaveName;
              if(fileList[i].Type =='身份证'){
                defaultListID.push(thisFile);
              }else if(fileList[i].Type =='营业执照'){
                defaultListBusiness.push(thisFile);
              }
            }
            this.d_defaultList_ID = defaultListID;
            this.d_defaultList_business = defaultListBusiness;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
//        图片赋值
//        this.$refs['formValidate'].validate((valid)=> {});//重新验证，不然会有提示
        this.d_modal_add = true;
      },
      add_modal_cancel(){
        this.d_modal_add = false;
      },
      edit_confirm (name) {
        let _this = this;
        this.add_params.FileList = [];
        let IDImgList = this.$refs.IDImgList.fileList;
        let businessImgList = this.$refs.businessImgList.fileList;
        let fileList = [];
        if(IDImgList.length>0){
          for(let i=0;i<IDImgList.length;i++){
            let currFile = {};
            currFile.OutType = 'customer';
            currFile.Type = '身份证';
            if(IDImgList[i].response){
              currFile.SaveName = IDImgList[i].response.Data;
            }else {
              currFile.SaveName = IDImgList[i].name;
            }
            fileList.push(currFile);
          }
        }
        if(businessImgList.length>0){
          for(let i=0;i<businessImgList.length;i++){
            let currFile = {};
            currFile.OutType = 'customer';
            currFile.Type = '营业执照';
            if(businessImgList[i].response){
              currFile.SaveName = businessImgList[i].response.Data;
            }else {
              currFile.SaveName = businessImgList[i].name;
            }
            fileList.push(currFile);
          }
        }
        this.add_params.FileList = fileList;
        if(!(this.add_params.IDNum || this.add_params.BusinessLicense)){
          this.$Message.error('身份证号和营业执照2选一，必填!',100);
          return
        }
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.submit_edit_data();
          } else {
            this.$Message.error('验证失败!');
          }
        })
      },
      submit_edit_data(){
        let _this = this;
        if(_this.d_modal_type=='add'){
          apiUser.add.post(this.add_params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              this.d_modal_add = false;
              this.$refs.IDImgList.clearFiles(); //不知道这句话在这里是否有用
              this.$refs.businessImgList.clearFiles();
              this.pull_data();
            }else {
              this.$Message.error(_data.data.Msg);
            }
          });
        }else if(_this.d_modal_type=='edit'){
          apiUser.edit.post(this.add_params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              this.d_modal_add = false;
              this.$refs.IDImgList.clearFiles();
              this.$refs.businessImgList.clearFiles();
              this.pull_data();
            }else {
              this.$Message.error(_data.data.Msg);
            }
          });
        }
      },
      to_delMore(){
        if(this.d_del_data.length>0){
          this.$Modal.confirm({
            title: "提示",
            content: "<p>您确认要删除这组数据吗？</p>",
            onOk: () => {
              this.to_delete(this.d_del_data);
            },
            onCancel: () => {}
          });
        }else {
          this.$Message.warning('请选择要删除的列');
        }
      },
      get_select_data(row){
        let delData = '';
        for(let i=0;i<row.length;i++){
          delData+=row[i].ID+',';
        }
        delData=(delData.substring(delData.length-1)==',')?delData.substring(0,delData.length-1):delData; // 去掉末尾逗号
        this.d_del_data = delData;
      },
      to_delete(_idList){
        apiUser.del(_idList).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.$Message.success('删除成功');
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },

      to_export(_type){ //导出
        // let condList = this.params.CondList[0];
        // if(condList.Value ===''){
        //   delete this.params.CondList;
        // }
        let _this = this;
        if(_type==='all'){
          this.params.PageIndex = 1;
          this.params.PageSize = 10000000;
          this.loading_export_all = true
        }else {
          this.loading_export = true
        }
        apiUser.export.post(this.params).then((_data) => {
          if(_data.data){
            setTimeout(function () {
              _this.loading_export = false;
              _this.loading_export_all = false;
            },1000)
            let blob = _data.data;
            let reader = new FileReader();
            reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
            reader.onload = function (e) {
              // 转换完成，创建一个a标签用于下载
              let a = document.createElement('a');
              a.download = '租户列表.xlsx';
              a.href = e.target.result;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
          }else {
            this.$Message.error('导出报表出现问题');
          }
        });
      }
    },
    created() {
      this.params = JSON.parse(JSON.stringify(apiUser.getList.data));
      this.params.CondList[0].Key = 'c.Name';
      this.add_params = JSON.parse(JSON.stringify(apiUser.add.data));
      this.pull_data();
    },
    mounted(){
      this.params.CondList[0].Key = 'c.ID'; //默认查询状态，产权证号
      this.params.CondList[0].Operator = 'like'; //默认全等查询
      this.token = sessionStorage.getItem('token');
    }
  }
</script>










